import React from 'react';
import { inject, observer } from 'mobx-react';
import H5SystemList from './h5';
import PCSystemList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface SystemListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    currentPage?: number;
    pageSize?: number;
    thread?: ThreadAction
    data?: any
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 threadList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    showRecommendUserList?: any    // 是否显示推荐关注用户，默认为false不显示 
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式

}
type SystemListAllProps = SystemListProps & RouteComponentProps;
interface SystemListState {
    recommendUserList: any
}
@inject('app', 'site', 'user', 'thread', 'topic')
@observer
class SystemList extends React.Component<SystemListAllProps, SystemListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            recommendUserList: [],
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        console.log('142453242');

    }

    // 处理触底加载下一页
    handleLoadMore = () => {
    };


    // 系统通知跳转
    itemClick = (itemData, optItem) => {
        const { app } = this.props;
        const platform = app?.platform || 'h5';
        if (!itemData) return;

        const data = itemData.data;
        const isPC = platform === 'pc';

        // PC 端统一提示
        if (isPC && itemData.type != 'thread') {
            Toast.info('下载App查看');
            return;
        }

        // 1. photography
        if (data?.type === 'photography') {
            const code = data.code;
            const workId = data.workId
            if (code) {
                this.props.history.push(`/photography/${code}?workId=${workId}`);
            }
            return;
        }

        // 2. lottery（不管是 system 还是其他类型）
        if (data?.type === 'lottery') {
            const lotteryCode = data.code;
            if (lotteryCode) {
                this.props.history.push(`/lottery/${lotteryCode}`);
            }
            return;
        }

        // 3. thread
        if (itemData.type === 'thread') {
            const threadId = data?.thread?.id;
            if (threadId) {
                this.props.history.push(`/threadDetail/${threadId}`);
            }
            return;
        }

        // 4. trial_product
        if (itemData.type === 'trial_product') {
            const trialId = data?.trialId;
            if (trialId) {
                this.props.history.push(`/productDetail/${trialId}`);
            }
            return;
        }

        // 5. 不属于以上四种类型 → 提示去 App 查看
        Toast.info('下载App查看');
    };


    // 去个人中心
    goUser = (user) => {
        console.log('跳转用户中心');
        if (this.props.history && user.code) {
            this.props.history.push(`/user/${user.code}`);
        }
    }

    render() {
        const { site, app, data, thread, onLoadMore, loading: propsLoading, hasMore: propsHasMore, namespace = 'usersPostsList', listStore, searchKeyword, emptyText,  emptyIcon, emptyBoxStyle, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let { recommendUserList } = this.state;
        // 确保传递 data 属性，即使为空数组
        const listData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        const store = listStore || thread?.listStore;
        const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        const loadMoreHandler = onLoadMore || this.handleLoadMore;

        if (platform === 'pc') {
            return <PCSystemList
                itemClick={this.itemClick}
                {...props}
                data={listData}
                loading={loading}
                hasMore={hasMore}
                onLoadMore={loadMoreHandler}
                emptyText={emptyText}
                emptyIcon={emptyIcon}
                emptyBoxStyle={emptyBoxStyle}
            />;
        } else {
            return <H5SystemList
            itemClick={this.itemClick}
            {...props}
            data={listData}
            loading={loading}
            hasMore={hasMore}
            onLoadMore={loadMoreHandler}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
        />;
        }
    }
}

export default withRouter(SystemList);